/**
 * Employee Incident Approval Types
 * Feature: individual approval of a marking incident (ASIS-5247 / REXASIS-005)
 * Endpoint: PUT /v1/attendances/incidents/{incidentId}/approval
 */

// Outcome discriminator constants — always HTTP 200, 'alreadyResolved' signals a
// concurrency conflict (someone else resolved the incident first).
export const INCIDENT_APPROVAL_OUTCOME = {
  APPROVED: 'approved',
  ALREADY_RESOLVED: 'alreadyResolved',
} as const;

export type IncidentApprovalOutcome =
  (typeof INCIDENT_APPROVAL_OUTCOME)[keyof typeof INCIDENT_APPROVAL_OUTCOME];

// Max length for the approver comment (mirrors the panel's local COMMENT_MAX_LENGTH).
export const INCIDENT_APPROVER_COMMENT_MAX_LENGTH = 100;

export interface LC_ApproveIncidentIn {
  approverComment: string; // REQUIRED
}

// Real current state of an already-resolved incident (concurrency case).
export interface LC_IncidentApprovalStateOut {
  status: string;
  approvedByFullName: string | null;
  approverComment: string | null;
  updatedDate: string | null; // ISO date-time
}

export interface LC_ApproveIncidentOut {
  outcome: IncidentApprovalOutcome;
  incidentId: number;
  newStatus: string;
  message: string;
  updatedDate: string | null; // ISO date-time
  // Only populated when outcome === 'alreadyResolved'.
  currentState: LC_IncidentApprovalStateOut | null;
}
